import * as microsoftTeams from '@microsoft/teams-js';
export default (function (_ref) {
  var app = _ref.app,
      router = _ref.router,
      store = _ref.store,
      Vue = _ref.Vue;
  microsoftTeams.app.initialize().then(function () {
    microsoftTeams.app.notifySuccess();
    microsoftTeams.app.getContext().then(function (context) {
      microsoftTeams.app.notifyAppLoaded();
      store.commit('app/setMicrosoftTeamsInitialized', true); // hide the Hubspot widget since it's in the way in microsoft teams

      window.hsConversationsSettings = {
        loadImmediately: false
      };
    }).catch(function () {});
  }).catch(function () {});
});